import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import { TicketType } from "../../../model/domain/Entity";
import { TicketCutoffDefaultType } from "../ticket-cutoff-type.model";
import { SnackbarService } from "../../../services/snackbar.service";
import { CutoffService } from "../../../services/cutoff.service";
import { DateTime } from "luxon";
import { TicketService } from "../../../services/ticket.service";

@Component({
  selector: "app-cutoff-default-update",
  templateUrl: "cutoff-default-update.component.html",
  styleUrls: ["./cutoff-default-update.component.scss"],
})
export class CutoffDefaultUpdateComponent implements OnInit {
  model: TicketCutoffDefaultType = null;
  type: string;
  form: FormGroup;
  history: any;

  accountManagerName: string;
  fundName: string;

  constructor(
    private fb: FormBuilder,
    private cutoffService: CutoffService,
    private ticketService: TicketService,
    private activatedRoute: ActivatedRoute,
    private snackBarService: SnackbarService
  ) {}

  ngOnInit() {
    this.createForm();
    this.getById();
    this.getHistory();
  }

  createForm() {
    this.form = this.fb.group({
      timeLimit: [
        "",
        [Validators.required, Validators.pattern(/[0-9]{2}:[0-9]{2}/)],
      ],
      isActive: [""],
    });
  }

  getById() {
    const id = +this.activatedRoute.snapshot.paramMap.get("id");

    this.cutoffService.get(id).subscribe((data: TicketCutoffDefaultType) => {
      this.model = data;
      this.type = data.cutoffType;
      this.form.setValue({
        timeLimit: this.cutoffService.dateTimeOffsetToTimeString(
          data.timeLimit
        ), // remove seconds,
        isActive: data.isActive,
      });

      if (data.accountManagerId) {
        this.form.get("isActive").enable();
      } else {
        this.form.get("isActive").disable();
      }

      if (this.model.accountManagerId) {
        const accountManager = [];
        accountManager.push(this.model.accountManagerId);
        this.ticketService
          .getFundsByAccountManagerIdList(accountManager)
          .subscribe((result) => {
            this.accountManagerName = result[0].accountManagerName;
            if (this.model.fundId) {
              this.fundName = result.find(
                (x) => x.id === this.model.fundId
              ).name;
            }
          });
      }
    });
  }

  getHistory(): void {
    const id = +this.activatedRoute.snapshot.paramMap.get("id");

    this.cutoffService.listDefaultHistory(id).subscribe((data) => {
      this.history = data;
    });
  }

  submit() {
    if (this.form.invalid) {
      return;
    }

    const data = Object.assign({}, this.model);
    data.timeLimit = this.form.get("timeLimit").value;

    data.timeLimit = data.timeLimit;

    data.isActive = this.form.get("isActive").value;

    this.cutoffService
      .put(this.model.id, data)
      .pipe(
        catchError((err) => {
          this.snackBarService.open(err, "OK");
          return throwError("Erro ao cadastrar a boleta.");
        })
      )
      .subscribe(() => {
        this.snackBarService.open("Horário limite default atualizado.", "OK");
        this.getHistory();
      });
  }
}
